module.exports = __webpack_public_path__ + "static/media/sports_4.a8ea69c5.jpg";